<div class="form-group" [formGroup]="forma" *ngIf="diuresis">
  <label for="diuresis" class="col-form-label"
    >{{ 'BIOMEDIDAS.VARIABLES.' + diuresis.alias + '.descripcion' | translate | capitalizado }} ({{
      'BIOMEDIDAS.VARIABLES.' + diuresis.alias + '.unidad' | translate
    }})</label
  >
  <div class="datoCol">
    <input
      type="text"
      [appFormatNumber]="diuresis.formato"
      appBlockCopyPaste
      class="form-control variable focus"
      id="diuresis"
      formControlName="diuresis"
    />
  </div>
</div>
<div
  class="filaError d-none"
  *ngIf="diuresis && botonActivadoPorProtocolo"
  [ngClass]="{ 'd-table-row': forma.controls['diuresis'].dirty && forma.controls['diuresis'].errors?.maxError }"
>
  <div class="d-none d-sm-table-cell"></div>
  <small class="error form-text text-muted"> {{ 'BIOMEDIDAS.DIURESIS.DIURESISMAX' | translate }}{{ diuresis.max }} </small>
</div>
<div
  class="filaError d-none"
  *ngIf="diuresis && botonActivadoPorProtocolo"
  [ngClass]="{ 'd-table-row': forma.controls['diuresis'].dirty && forma.controls['diuresis'].errors?.minError }"
>
  <div class="d-none d-sm-table-cell"></div>
  <small class="error form-text text-muted"> {{ 'BIOMEDIDAS.DIURESIS.DIURESISMIN' | translate }}{{ diuresis.min }} </small>
</div>
<div
  class="filaError d-none"
  *ngIf="diuresis && botonActivadoPorProtocolo"
  [ngClass]="{ 'd-table-row': forma.controls['diuresis'].dirty && forma.controls['diuresis'].errors?.required }"
>
  <div class="d-none d-sm-table-cell" ></div>
  <small class="error form-text text-muted" >
    {{ 'BIOMEDIDAS.DIURESIS.DIURESISREQUERIDO' | translate }}
  </small>
</div>
